import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import ModalCMS from '../components/Modals/CMSModal';

const CONTEXT_DEFAULT_VALUES = {
  isOpened: false,
  isTimeLimitModal: true,
  isInCustodyModal: false,
  isInStructurePopModal: false,
  title: '',
  content: [''],
  isNotification: false,
};

const CMSModalContext = createContext({
  ...CONTEXT_DEFAULT_VALUES,
  openTimeLimitModal: () => {},
  openInCustodyModal: () => {},
  openInStructurePopModal: () => {},
  openVerifyDoublePOP: () => {},
  closeModal: () => {},
});

export const CMSModalProvider = ({ children, notificationDispatch }) => {
  const [store, setStore] = useState(CONTEXT_DEFAULT_VALUES);

  const handleOnFunction = (isOpened, isTimeLimitModal, isInCustodyModal, isInStructurePopModal, title, content, isNotification) => {
    setStore({
      isOpened,
      isTimeLimitModal,
      isInCustodyModal,
      isInStructurePopModal,
      title,
      content,
      isNotification,
    });
  };

  return (
    <CMSModalContext.Provider
      value={{
        ...store,
        openTimeLimitModal: () => handleOnFunction(true, true, false, false, 'Novas mensagens', [
          'Você têm mensagens com grandes oportunidades não lidas!',
        ], true),
        openInCustodyModal: () => handleOnFunction(true, false, true, false, 'OPERAÇÃO SOB CUSTÓDIA, AVISO IMPORTANTE!', [
          'Atenção: Esta operação é sob custódia e não envolve a compra automática do ativo subjacente.',
          'Certifique-se de que o cliente já possua o ativo subjacente em sua carteira antes de fazer a contratação, caso contrário o seu resultado poderá ser materialmente diferente do descrito nesta lâmina.',
          'A contratação desta operação sem a compra do ativo subjacente e, posterior possível venda para auferir o correto resultado da mesma, é de responsabilidade do assessor.',
        ], false),
        openInStructurePopModal: () => handleOnFunction(true, false, false, true, 'AVISO IMPORTANTE!', [
          'Atenção: A operação POP envolve a compra do DOBRO da posição de ativo subjacente para cada lote da estrutura.',
          'Esta estrutura possui características operacionais específicas.',
          'Exemplo: Um lote de 100 estruturas implica na compra de 200 lotes do ativo subjacente para a conta do cliente.',
        ], false),
        openVerifyDoublePOP: ({ quantidadeDigitada, precoReferencia }) => handleOnFunction(true, false, false, true, 'AVISO IMPORTANTE!', [
          'Atenção: A operação POP envolve a compra do DOBRO da posição de ativo subjacente para cada lote de estrutura.',
          'Na ordem enviada ({quantidadeDigitada} quantidades), será executado o volume financeiro considerando {quantidadeDigitada * 2} quantidades, ou seja, R${quantidadeDigitada * 2 * precoReferencia}.',
          'Para executar {quantidadeDigitada} quantidades da estrutura, é necessário enviar o push da metade dessa quantidade ({quantidadeDigitada / 2}).',
        ], false),
        closeModal: () => handleOnFunction(false, false, false, false, '', [''], false),
      }}
    >
      <ModalCMS notificationDispatch={notificationDispatch} />
      {children}
    </CMSModalContext.Provider>
  );
};

CMSModalProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  notificationDispatch: PropTypes.func.isRequired,
};

export const useCMSModal = () => {
  const context = useContext(CMSModalContext);

  if (!context) {
    throw new Error('useCMSModal must be used within an CMSModalProvider.');
  }

  return context;
};
